<template>
    <div>
        <v-app>
            <v-navigation-drawer app v-if="false">
                <!-- -->
            </v-navigation-drawer>

            <v-app-bar app>

                            
                    <img :src="navbarImage" width="210px"/>
                    
                    <v-spacer></v-spacer>

                    <div class="searchClass d-none d-sm-flex">
                        <v-text-field
                            clearable
                            autocomplete="off"
                            key="search"
                            v-model="search"
                            label="App search"
                            placeholder="Search"
                            rounded
                            dense
                            solo
                            color="success"
                        ></v-text-field>
                    </div>

                    <ThemeSwitch
                    class="themeSwitchClass"
                    :propsChecked="darkTheme"
                    @value="changeTheme"
                    >
                    </ThemeSwitch>

                    <img :src="photoSrc" width="35px" :style="{borderRadius: '10px'}"/>

                    <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                @click="logoutHandler" 
                                >
                                <v-icon>logout</v-icon>
                                </v-btn>
                            </template>
                            <span >logout</span>
                    </v-tooltip>

            </v-app-bar>

            <!-- Sizes your content based upon application components -->
            <v-main>

                <!-- Provides the application the proper gutter -->
                <v-container class="container" fluid>

                    <!--child-->
                    <slot></slot>
                    
                </v-container>
            </v-main>

            <v-footer
            app
            padless
            >
                <CustomFooter
                :srcProp="footerImage"
                ></CustomFooter>
                <!-- -->
            </v-footer>
        </v-app>

    </div>
</template>

<script>

//css
import "./MainLayout.css"

//url
import {ImageUrl} from "@/UrlService.js"

import CustomFooter from "@/components/footer/CustomFooter.vue"

import ThemeSwitch from "@/components/switch/ThemeSwitch.vue"

//Query
import {
    QueryGetUserPhoto
} from "@/constants/graphql.js"

export default {

    components:{
        CustomFooter,
        ThemeSwitch
    },

    //Dependency injection
    provide() {
        return {
            getSearch: () => this.search,
        }
    },

    data: function(){
        return({
            darkTheme: this.$vuetify.theme.dark,
            navbarImage: ImageUrl() + "?filename=nikita_spqr.png",
            footerImage: this.$vuetify.theme.dark ? ImageUrl() + '?filename=W3_NEG_RGB.png' : ImageUrl() +'?filename=W3_RGB.png',
            search: null,
        })
    },
    
    methods:{

        changeTheme(){
            this.darkTheme = !this.darkTheme;
            if (this.darkTheme) {
                this.$vuetify.theme.dark = true;
                this.footerImage = ImageUrl() + '?filename=W3_NEG_RGB.png'
            } else {
                this.$vuetify.theme.dark = false;
                this.footerImage = ImageUrl() + '?filename=W3_RGB.png'
            }
        },

        //Logout handler. Redirect to login page
        logoutHandler(){
            this.$router.push({name: "logout", replace: true})
        }
    },

    apollo: {

        photoSrc: {
            query: QueryGetUserPhoto,
            update: (data) => {
                debugger;
                return "data:image/jpeg;base64," + data.getUserPhoto
            },
        },
    }
    
}
</script>

<style scoped>
.themeSwitchClass{
    margin-right: 5px;
}

</style>